/* eslint-disable prefer-promise-reject-errors */
// Adapted from https://ghe.spotify.net/creator/s4a-coda/blob/master/src/app/Concerts/ConcertView/ConcertsListing/ConcertShare/copyToClipboard.js
function copyFromDataUri(textToCopy) {
  return new Promise((resolve, reject) => {
    const elem = document.createElement('input');
    elem.value = textToCopy;
    document.body.appendChild(elem);

    elem.select();
    elem.setSelectionRange(0, textToCopy.length);

    const response = document.execCommand('copy');

    document.body.removeChild(elem);

    return response ? resolve(textToCopy) : reject(false);
  });
}

// copy the contents of an htmlElement's `value` attribute
// to the clipboard
export function copy(textToCopy) {
  // even though execCommand will return false if the command is unsupported
  // we can short circuit here to prevent a DOM read operation.
  if (!document.queryCommandSupported('copy')) return Promise.reject(false);

  // if there isn't anything to copy, like empty text,
  // don't copy it and resolve to false
  if (!textToCopy) return Promise.reject(false);

  return copyFromDataUri(textToCopy);
}
